import { useLocation } from '@tanstack/react-router'
import { ThemeProvider } from 'next-themes'
import { PropsWithChildren } from 'react'

import { ThemeShortcut } from '@/components/theme-shortcut'
import { CheckpointProvider } from '@/contexts/checkpoint-context'
import { DocumentPreviewProvider } from '@/contexts/document-preview-context'
import { RepairPartsActionProvider } from '@/contexts/repair-parts-action-context'
import { FirebaseUserContextProvider } from '@/hooks/useFirebaseUser'
import { initI18n } from '@/i18n'
import { useDateFnsConfiguration } from '@/integrations/date-fns'
import { useZodLocale } from '@/integrations/zod'

import { QueryProvider } from './QueryProvider'
import { ReduxProvider } from './ReduxProvider'

initI18n()

export const Providers = ({ children }: PropsWithChildren) => {
  useZodLocale()
  useDateFnsConfiguration()
  const location = useLocation()

  return (
    <ThemeProvider
      attribute="class"
      enableSystem={false}
      forcedTheme={location.pathname.startsWith('/login') ? 'light' : undefined}
    >
      <ThemeShortcut />
      <ReduxProvider>
        <QueryProvider>
          <FirebaseUserContextProvider>
            <DocumentPreviewProvider>
              <CheckpointProvider>
                <RepairPartsActionProvider>{children}</RepairPartsActionProvider>
              </CheckpointProvider>
            </DocumentPreviewProvider>
          </FirebaseUserContextProvider>
        </QueryProvider>
      </ReduxProvider>
    </ThemeProvider>
  )
}
